import React from "react";
import {
  ActionPopover,
  ActionPopoverItem,
  ActionPopoverDivider,
} from "carbon-react/lib/components/action-popover";
import { useUserApi } from "../../services/UserApi";
import { useAppContext } from "../../contexts/AppContext";
import { useHistory } from "react-router-dom";
import appRoutes from "../Navigation/appRoutes";

const UserPopOverContextMenu = (props) => {
  const { blockUser, unblockUser } = useUserApi();
  const { agentEntitlement } = useAppContext();
  const history = useHistory();
  const { bypassMfa: bypassMfa } = useUserApi();

  // TODO: RB - refactor this duplication
  const dialogStates = {
    blockUserState: {
      captureLanguage: true,
      title: `Block user`,
      userHeading: `${props.user?.name} (${props.user?.email})`,
      subTitle:
        "Blocking this user will disable the account, thereby preventing access to all associated services/products.",
      promptCaption: "Confirm",
      prompts: [
        "Before proceeding, please ensure that you have positively verified that the person requesting this action is the owner of the account.",
      ],
      buttonCaption: "Block user",
      performAction: async (params) => {
        const result = await blockUser(
          props.user?.userId,
          params?.languageCode,
          params?.agentComments
        );
        if (!result.success)
          throw new Error(result.error?.description || "Failed to block user");
        props.onUpdateUser(result.data);
      },
      successToast: `User blocked '${props.user?.email}'.`,
    },
    unblockUserState: {
      captureLanguage: true,
      title: `Unblock user`,
      userHeading: `${props.user?.name} (${props.user?.email})`,
      subTitle:
        "Unblocking this user will re-enable the account, thereby restoring access to all associated services/products.",
      promptCaption: "Confirm",
      prompts: [
        "Before proceeding, please ensure that you have positively verified that the person requesting this action is the owner of the account.",
      ],
      buttonCaption: "Unblock user",
      performAction: async (params) => {
        const result = await unblockUser(
          props.user?.userId,
          params?.languageCode,
          params?.agentComments
        );
        if (!result.success)
          throw new Error(
            result.error?.description || "Failed to unblock user"
          );
        props.onUpdateUser(result.data);
      },
      successToast: `User unblocked '${props.user?.email}'.`,
    },
  };

  const popoverItem_ViewDetail = (
    <ActionPopoverItem
      id="user-actions-menu-detail"
      icon={"person"}
      disabled={false}
      onClick={() => {
        history.push(`${appRoutes.user}/${props.user?.userId}`);
      }}
    >
      Detail information
    </ActionPopoverItem>
  );

  const popoverItem_Block_Unblock =
    props.user?.blocked === true
      ? agentEntitlement &&
        agentEntitlement.users.canUnblock && (
          <ActionPopoverItem
            id="user-actions-menu-unblock"
            icon={"unlocked"}
            disabled={false}
            onClick={() => {
              props.openCommentsDialog(dialogStates.unblockUserState);
            }}
          >
            Unblock user
          </ActionPopoverItem>
        )
      : agentEntitlement &&
        agentEntitlement.users.canBlock && (
          <ActionPopoverItem
            id="user-actions-menu-block"
            icon={"locked"}
            disabled={false}
            onClick={() => {
              props.openCommentsDialog(dialogStates.blockUserState);
            }}
          >
            Block user
          </ActionPopoverItem>
        );

  const popoverItem_ConfirmEmailAccess = agentEntitlement &&
    agentEntitlement.users.canVerifyEmailAccess && (
      <ActionPopoverItem
        id="user-actions-menu-confirm-email-access"
        icon={"person_tick"}
        disabled={false}
        onClick={() => {
          props.openVerifyEmailAccessDialog(props.user);
        }}
      >
        Confirm email access
      </ActionPopoverItem>
    );

  const popoverItem_Delete = agentEntitlement &&
    agentEntitlement.users.canDelete && (
      <ActionPopoverItem
        id="user-actions-menu-delete"
        icon={"bin"}
        disabled={false}
        onClick={() => {
          props.openDeleteUserDialog(props.user);
        }}
      >
        Delete user
      </ActionPopoverItem>
    );

  const popoverItem_BypassEmailVerification = agentEntitlement &&
    agentEntitlement.users.canBypassEmailVerification && (
      <ActionPopoverItem
        id="user-actions-menu-bypass-email-verification"
        icon={"arrow"}
        disabled={false}
        onClick={() => {
          props.openBypassEmailVerificationDialog(props.user);
        }}
      >
        Bypass email verification
      </ActionPopoverItem>
    );

    const popoverItem_BypassMfa = agentEntitlement &&
      agentEntitlement.users.canBypassMfa && (
        <ActionPopoverItem
          id="user-actions-menu-change-email"
          icon={"person"}
          disabled={false}
          onClick={() => {
            props.openBypassMfaDialog(props.user);
          }}
        >
          {
            props.user.mfaBypassEnabled ? "Disable MFA Bypass":" Bypass MFA"
          }

        </ActionPopoverItem>
      );


  const popoverItem_ChangeEmail = agentEntitlement &&
    agentEntitlement.users.canChangeEmail && (
      <ActionPopoverItem
        id="user-actions-menu-change-email"
        icon={"email"}
        disabled={false}
        onClick={() => {
          props.openChangeEmailDialog(props.user);
        }}
      >
        Change email address
      </ActionPopoverItem>
    );

  const popoverItem_ResetPassword = agentEntitlement &&
    agentEntitlement.users.canResetPassword && (
      <ActionPopoverItem
        id="user-actions-menu-reset-password"
        icon={"key"}
        disabled={false}
        onClick={() => {
          props.openResetPasswordDialog(props.user);
        }}
      >
        Reset password
      </ActionPopoverItem>
    );

  return (
    <ActionPopover id="user-actions-menu">
      {popoverItem_ViewDetail}
      <ActionPopoverDivider />
      {popoverItem_ConfirmEmailAccess}
      {popoverItem_ChangeEmail}
      {popoverItem_Block_Unblock}
      {popoverItem_ResetPassword}
      {popoverItem_Delete}
      {popoverItem_BypassEmailVerification}
      {popoverItem_BypassMfa}
    </ActionPopover>
  );
};

export default UserPopOverContextMenu;
